(function(){
  var BANNER_WEB='https://cdn.shopify.com/s/files/1/0711/6813/1203/files/toran-option-4-web-2000x560.png?v=1788880344';
  var BANNER_MOB='https://cdn.shopify.com/s/files/1/0711/6813/1203/files/toran-option-4-mobile-1080x700.png?v=1788880344';
  var HERO_WEB='https://cdn.shopify.com/s/files/1/0711/6813/1203/files/toran-desktop-final-option-2-sage.png?v=1788878860';
  var HERO_MOB='https://cdn.shopify.com/s/files/1/0711/6813/1203/files/toran-mobile-final-option-2-sage.png?v=1788878860';
  var HANG_WEB='https://cdn.shopify.com/s/files/1/0711/6813/1203/files/Hanging_Web.png?v=1789811476';
  var HANG_MOB='https://cdn.shopify.com/s/files/1/0711/6813/1203/files/Hanging_Mobile.png?v=1789811476';
  var TEAL_WEB='https://cdn.shopify.com/s/files/1/0711/6813/1203/files/Tea_light_-_Web.png?v=1789811476';
  var TEAL_MOB='https://cdn.shopify.com/s/files/1/0711/6813/1203/files/Tea_Light_Mobile.png?v=1789811476';
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    (function(){
      var nav=document.querySelector('.tyo-fest-nav');
      if(nav && !nav.querySelector('[data-tyo-toran-tab]')){
        var a=document.createElement('a');
        a.className='tyo-fest-nav-item';
        a.setAttribute('data-tyo-toran-tab','1');
        a.href='/collections/toran';
        a.innerHTML='🎀 Toran';
        nav.insertBefore(a, nav.firstChild);
      }
    })();
    (function(){
      var track=document.getElementById('tyoTrendTrack');
      if(!track || track.getAttribute('data-tyo-trend')) return;
      track.setAttribute('data-tyo-trend','1');
      var CDN='https://cdn.shopify.com/s/files/1/0711/6813/1203/files/';
      var TILES=[
        {l:'Toran',                 h:'/collections/toran',        i:'TYO-TOH-027-02.png?width=340'},
        {l:'Tea Lights',            h:'/collections/tea-light',    i:'green-hero.png?width=340'},
        {l:'Charan Padika',         h:'/collections/charan-padika',i:'cp1-overhead.png?v=1789810855&width=340'},
        {l:'Hangings',              h:'/collections/hanging',      i:'green-pom-pom-bell-hanging-pair-of-2-view-1.png?width=340'},
        {l:'Mala',                  h:'/collections/mala',         i:'TYO-MALA-001-03.png?width=340'},
        {l:'Shubh Labh',            h:'/collections/shubh-labh',   i:'TYO-SHL-012-1.png?width=340'},
        {l:'Peacock Tealight Sets', h:'https://tyohaare-peacock-decor.shreshth341274.chatgpt.site', i:'peacock-tealight-sets-category.png?v=1788592054&width=340'},
        {l:'Gift Hampers',          h:'/collections/gift-hampers', i:'TYO-GIF-017-01.png?width=340'}
      ];
      track.innerHTML=TILES.map(function(t){
        return '<a class="tyo-cat4-tile" href="'+t.h+'"><div class="tyo-cat4-frame"><img src="'+CDN+t.i+'" alt="'+t.l+'" width="340" height="340" loading="lazy"></div><div class="tyo-cat4-label">'+t.l+'</div></a>';
      }).join('');
      try{ window.dispatchEvent(new Event('resize')); }catch(e){}
    })();
    var track = document.querySelector('.tyo-ann-track');
    if(track){
      var items=[
        '🎀 <strong>Toran Collection</strong> — Handcrafted door Torans',
        '🎁 <strong>Gift Collection</strong> — Curated festive hampers',
        '🕯️ <strong>Tea Lights</strong> — Mirror &amp; pearl designs',
        "🏺 India’s First Festival Living Brand — <strong>That’s Tyohaare</strong>",
        '🪔 Diwali 2026 — Torans, Diyas &amp; Kits',
        '🔒 Secure Payments — UPI · Cards · NetBanking · COD'
      ];
      track.innerHTML=items.concat(items).map(function(t){return '<div class="tyo-ann-item">'+t+' <div class="tyo-ann-dot"></div></div>';}).join('');
    }
    var list=document.querySelector('.tyo-fest-list');
    if(list){
      var fests=[
        {n:'Ganesh Chaturthi', d:'2026-09-14T00:00:00+05:30', u:'/collections/singhasan'},
        {n:'Navratri',         d:'2026-10-11T00:00:00+05:30', u:'/collections/mala'},
        {n:'Dussehra',         d:'2026-10-20T00:00:00+05:30', u:'/collections/toran'},
        {n:'Diwali',           d:'2026-11-08T00:00:00+05:30', u:'/collections/tea-light'}
      ];
      list.innerHTML=fests.map(function(f){return '<a class="tyo-fest-card" href="'+f.u+'" data-festival-date="'+f.d+'"><span class="tyo-fest-name">'+f.n+'</span><span class="tyo-fest-time" data-festival-time>Loading…</span><span class="tyo-fest-action">Shop now</span></a>';}).join('');
      function tick(){
        document.querySelectorAll('.tyo-fest-list [data-festival-date]').forEach(function(card){
          var o=card.querySelector('[data-festival-time]'); if(!o) return;
          var diff=new Date(card.getAttribute('data-festival-date')).getTime()-Date.now();
          if(diff<=0){ o.textContent='Festival is here'; return; }
          var d=Math.floor(diff/864e5),h=Math.floor(diff%864e5/36e5),m=Math.floor(diff%36e5/6e4),s=Math.floor(diff%6e4/1e3);
          o.innerHTML='<strong>'+d+'</strong> days &nbsp; <strong>'+String(h).padStart(2,'0')+'</strong> hrs &nbsp; <strong>'+String(m).padStart(2,'0')+'</strong> min &nbsp; <strong>'+String(s).padStart(2,'0')+'</strong> sec';
        });
      }
      tick(); if(!window.__tyoFestTimer){ window.__tyoFestTimer=setInterval(tick,1000); }
    }
    if(list && !document.getElementById('tyo-toran-banner')){
      var sec=list.closest('[id^="shopify-section-"]')||list.parentElement;
      if(!document.getElementById('tyo-tbanstrip-css')){
        var bcss=document.createElement('style'); bcss.id='tyo-tbanstrip-css';
        bcss.textContent='#tyo-toran-banner .tyo-tban-strip{display:block;width:100%;height:150px;object-fit:cover;object-position:center}@media(max-width:700px){#tyo-toran-banner .tyo-tban-strip{height:104px}}';
        document.head.appendChild(bcss);
      }
      var b=document.createElement('div'); b.id='tyo-toran-banner';
      b.innerHTML='<a href="/collections/toran" style="display:block;line-height:0"><picture>'+
        '<source media="(max-width:700px)" srcset="'+BANNER_MOB+'">'+
        '<img class="tyo-tban-strip" src="'+BANNER_WEB+'" alt="Exclusive Toran Collection" loading="lazy"></picture></a>';
      if(sec && sec.parentNode) sec.parentNode.insertBefore(b, sec.nextSibling);
    }
    (function(){
      var hero=document.querySelector('.tyo-hero');
      if(!hero || hero.getAttribute('data-tyo-rebuilt')) return;
      hero.setAttribute('data-tyo-rebuilt','1');
      var MQ='(max-width:767px)';
      var BANNERS=[
        {href:'/collections/hanging',  web:HANG_WEB, mob:HANG_MOB, alt:'Hanging Collection',   fp:true},
        {href:'/collections/tea-light',web:TEAL_WEB, mob:TEAL_MOB, alt:'Tea Light Collection', fp:false},
        {href:'/collections/toran',    web:HERO_WEB, mob:HERO_MOB, alt:'The Toran Collection',  fp:false}
      ];
      if(!document.getElementById('tyo-hero-css')){
        var st=document.createElement('style'); st.id='tyo-hero-css';
        st.textContent='.tyo-hero{font-family:"DM Sans",-apple-system,sans-serif}#tyoHC{position:relative;width:100%;max-width:1440px;margin:0 auto;overflow:hidden;background:#1A0A14;aspect-ratio:2/1}#tyoHT{display:flex;height:100%;transition:transform .7s cubic-bezier(.4,0,.2,1);will-change:transform}#tyoHC .tyo-slide{min-width:100%;width:100%;flex-shrink:0;height:100%;position:relative;overflow:hidden}#tyoHC .tyo-slide>a{display:block;width:100%;height:100%;line-height:0}#tyoHC .tyo-slide img{width:100%;height:100%;object-fit:cover;display:block}#tyoHD{position:absolute;bottom:14px;left:50%;transform:translateX(-50%);display:flex;gap:8px;z-index:10}#tyoHD .tyo-dot{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,.45);cursor:pointer;border:none;padding:0;transition:all .2s}#tyoHD .tyo-dot.active{background:#fff;transform:scale(1.25)}@media(max-width:767px){#tyoHC{aspect-ratio:1/1;max-width:none}}';
        document.head.appendChild(st);
      }
      var slidesHTML=BANNERS.map(function(x){
        return '<div class="tyo-slide"><a href="'+x.href+'" aria-label="'+x.alt+'"><picture>'+
          '<source media="'+MQ+'" srcset="'+x.mob+'">'+
          '<img src="'+x.web+'" alt="'+x.alt+'" width="1774" height="887"'+(x.fp?' fetchpriority="high"':' loading="lazy"')+'></picture></a></div>';
      }).join('');
      var dotsHTML=BANNERS.map(function(x,i){return '<button type="button" class="tyo-dot'+(i===0?' active':'')+'" aria-label="Show banner '+(i+1)+'"></button>';}).join('');
      hero.innerHTML='<div id="tyoHC"><div id="tyoHT">'+slidesHTML+'</div><div id="tyoHD">'+dotsHTML+'</div></div>';
      var C=document.getElementById('tyoHC'), T=document.getElementById('tyoHT'), D=document.getElementById('tyoHD');
      var slides=T.querySelectorAll('.tyo-slide'), dots=D.querySelectorAll('.tyo-dot');
      var cur=0, timer=null, reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function go(n){ cur=(n+slides.length)%slides.length; T.style.transform='translate3d(-'+(cur*100)+'%,0,0)'; for(var i=0;i<dots.length;i++) dots[i].classList.toggle('active',i===cur); }
      function stop(){ if(timer){ clearInterval(timer); timer=null; } }
      function start(){ stop(); if(!reduce) timer=setInterval(function(){ go(cur+1); },5500); }
      for(var i=0;i<dots.length;i++){ (function(k){ dots[k].addEventListener('click',function(){ go(k); start(); }); })(i); }
      C.addEventListener('mouseenter',stop); C.addEventListener('mouseleave',start);
      var sx=0;
      C.addEventListener('touchstart',function(e){ sx=e.touches[0].clientX; stop(); },{passive:true});
      C.addEventListener('touchend',function(e){ var df=e.changedTouches[0].clientX-sx; if(Math.abs(df)>45) go(cur+(df<0?1:-1)); start(); },{passive:true});
      go(0); start();
    })();
  });
})();
